import { graphql, useStaticQuery } from 'gatsby';

import type { Lucid } from 'types/types';

const useBlogNewsletter = (languageKey: Lucid.I18n.LanguagesShortCode) => {
  const {
    directus: { newsletter },
  } = useStaticQuery<Lucid.Query.Hooks.UseBlogNewsletter>(graphql`
    query BlogNewsletterQuery {
      directus {
        newsletter: contact_form_by_id(id: "4") {
          translations {
            languages_code {
              short_code
            }
            path {
              url
            }
          }
        }
      }
    }
  `);

  // use the translated path first, then the english path, then fallback to a hard coded path if nothing is found.
  const staticPath = '/contact/newsletter';
  const enPath = newsletter?.translations.find(translation => translation.languages_code?.short_code === 'en');
  const trPath = newsletter?.translations.find(translation => translation.languages_code?.short_code === languageKey);
  const newsletterSignUpURL = trPath?.path?.url || enPath?.path?.url || staticPath;

  return {
    newsletterSignUpURL,
  };
};

export default useBlogNewsletter;
